import React, { useState } from "react";
import "./order-page.css";
import LayoutDashboard from "layouts/layout-dashboard-collapse";

const categories = [
  {
    id: 1,
    name: "Breakfast",
    count: 12,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-sun"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <circle cx="12" cy="12" r="4" />
        <path d="M3 12h1m16 0h1" />
        <path d="M12 3v1m0 16v1" />
        <path d="M5.6 5.6l.7 .7m12.1 12.1l.7 .7" />
        <path d="M18.4 5.6l-.7 .7m-12.1 12.1l-.7 .7" />
      </svg>
    ),
  },
  {
    id: 2,
    name: "Lunch",
    count: 12,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-burger"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 16l1 1h16l1 -1z" />
        <path d="M4 14h16v2h-16z" />
        <path d="M4 8h16v2h-16z" />
        <path d="M4 5h16v2h-16z" />
      </svg>
    ),
  },
  {
    id: 3,
    name: "Dinner",
    count: 12,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-moon"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 3c.132 0 .262 .007 .393 .02a9 9 0 1 0 9.587 9.587a9 9 0 0 1 -9.98 -9.607z" />
      </svg>
    ),
  },
  {
    id: 4,
    name: "Soup",
    count: 12,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="icon icon-tabler icon-tabler-bowl"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 12h18" />
        <path d="M5 12a7 7 0 0 1 14 0v3h-14v-3" />
        <path d="M5 15h14" />
      </svg>
    ),
  },
  // Tambahkan kategori lainnya dengan ikon sesuai kebutuhan
];

const menuItems = [
  {
    id: 1,
    name: "Pasta Bolognese",
    price: 50.5,
    description: "Delicious pasta with sauce",
    image:
      "https://i.pinimg.com/474x/d9/c4/f0/d9c4f02a9e4013822b7a42703df53fa1.jpg",
  },
  {
    id: 2,
    name: "Spicy Fried Chicken",
    price: 45.7,
    description: "Crispy fried chicken with spice",
    image:
      "https://i.pinimg.com/474x/20/8b/0b/208b0b1ec83a443dbdb8f625d453da64.jpg",
  },
  {
    id: 3,
    name: "Grilled Steak",
    price: 80,
    description: "Juicy steak with grilled perfection",
    image:
      "https://i.pinimg.com/474x/59/1d/90/591d90d90d1964024525783647cf99c4.jpg",
  },
  {
    id: 4,
    name: "Fish And Chips",
    price: 90.4,
    description: "Classic fish and chips",
    image:
      "https://i.pinimg.com/474x/f3/e7/cc/f3e7cc62b5d13b70b1e333a3c5079e40.jpg",
  },
];

const OrderPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("Lunch");
  const [cart, setCart] = useState([]);

  const addToCart = (item) => {
    const existingItem = cart.find((cartItem) => cartItem.id === item.id);
    if (existingItem) {
      setCart(
        cart.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        )
      );
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
    }
  };

  const removeFromCart = (item) => {
    const existingItem = cart.find((cartItem) => cartItem.id === item.id);
    if (existingItem.quantity === 1) {
      setCart(cart.filter((cartItem) => cartItem.id !== item.id));
    } else {
      setCart(
        cart.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity - 1 }
            : cartItem
        )
      );
    }
  };

  const calculateTotal = () => {
    const subtotal = cart.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
    const tax = subtotal * 0.04; // 4% tax
    return { subtotal, tax, total: subtotal + tax };
  };

  const { subtotal, tax, total } = calculateTotal();

  return (
    <LayoutDashboard>
      <div className="bg-white">
        <div className="container mt-4">
          <div className="row">
            <div className="col-8">
              {/* Kategori Menu */}
              <div className="row g-3 mb-4">
                {categories.map((category) => (
                  <div
                    key={category.id}
                    className={`col-12 col-sm-6 col-md-4 col-lg-3 `}
                    onClick={() => setSelectedCategory(category.name)}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <div
                      className={`card p-2 ${
                        selectedCategory === category.name
                          ? "bg-primary text-white"
                          : "bg-light"
                      }`}
                      style={{
                        borderRadius: "10px",
                        cursor: "pointer",
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                        transition: "transform 0.2s, box-shadow 0.2s",
                      }}
                    >
                      {/* Ikon */}
                      <div className="row">
                        <div className="col-4">
                          <div
                            style={{
                              marginBottom: "10px",
                              fontSize: "2rem",
                            }}
                          >
                            {category.icon}
                          </div>
                        </div>
                        <div className="col-8">
                          {/* Nama Kategori */}
                          <h4 className="mb-1">{category.name}</h4>

                          {/* Informasi Stock */}
                          <small>{category.count} Menu In Stock</small>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Daftar Menu */}
              <div className="row">
                {menuItems.map((item) => (
                  <div className="col-md-4 mb-4" key={item.id}>
                    <div className="card h-100">
                      <img
                        src={item.image}
                        className="card-img-top"
                        alt={item.name}
                        style={{ height: "150px", objectFit: "cover" }}
                      />
                      <div className="card-body">
                        <h5 className="card-title">{item.name}</h5>
                        <p className="card-text">{item.description}</p>
                        <h6>Rp {item.price.toLocaleString()}</h6>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => removeFromCart(item)}
                          >
                            -
                          </button>
                          <span>
                            {cart.find((cartItem) => cartItem.id === item.id)
                              ?.quantity || 0}
                          </span>
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => addToCart(item)}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-4 card">
              {/* Keranjang */}
              <div className="row ">
                <div className="col-12">
                  <h4>Invoice</h4>
                  {cart.length === 0 ? (
                    <p className="text-muted">Keranjang kosong</p>
                  ) : (
                    <ul className="list-group">
                      {cart.map((item) => (
                        <li
                          className="list-group-item d-flex justify-content-between align-items-center"
                          key={item.id}
                        >
                          <div>
                            <strong>{item.name}</strong>
                            <br />
                            {item.quantity} x Rp {item.price.toLocaleString()}
                          </div>
                          <span>
                            Rp {(item.price * item.quantity).toLocaleString()}
                          </span>
                        </li>
                      ))}
                      <li className="list-group-item d-flex justify-content-between">
                        <strong>Subtotal</strong>
                        <span>Rp {subtotal.toLocaleString()}</span>
                      </li>
                      <li className="list-group-item d-flex justify-content-between">
                        <strong>Tax (4%)</strong>
                        <span>Rp {tax.toLocaleString()}</span>
                      </li>
                      <li className="list-group-item d-flex justify-content-between">
                        <strong>Total</strong>
                        <span>Rp {total.toLocaleString()}</span>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default OrderPage;
